import { getCssVariableValue } from '../utils'

export class Chart {
    constructor() {
    }

    getParentChartOption() {
        return {
            grid: {
                left   : '1%',
                top    : '30px',
                bottom : '3%',
                right  : '2%',
                containLabel: true
            },
            tooltip : {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross'
                },
                padding : 0,
                borderColor  : getCssVariableValue('--main'),
                backgroundColor : getCssVariableValue('--chart-tooltip-bg'),
                extraCssText: 'backdrop-filter: blur(25px);',
                formatter: this._getTooltipFormatter,
            },
            dataZoom: [
                {
                    xAxisIndex: [0, 1],
                    type: 'inside',
                    start: 0,
                    end: 100,
                    // filterMode: "none"
                    // filterMode: "empty"
                },
                {
                    show: false,
                    xAxisIndex: [0, 1],
                    type: 'slider',
                    top: '100%',
                    start: 0,
                    end: 100,
                }
            ],

            legend  : {
                data : [],
                show: true,
                type: 'scroll',
                animationDurationUpdate: 100,
                pageTextStyle: {
                    color: "#cccccc"
                },
                itemGap : 25,

                pageIconColor: 'white',
                pageIconInactiveColor: 'gray',
                orient : "horizontal",
                right  : "0",
                width  : '60%',
                textStyle : {
                    color: 'white'
                },
                itemStyle:{
                    opacity: 0,
                },
            },
            xAxis: {
                data : []
            },
            yAxis: {
                type        : "value",
                boundaryGap : [0, '2%'],
                axisPointer : { label: { show: true}},
                scale: true,
                splitLine: {
                    show        : true,
                    lineStyle   : {
                        width : 0.5,
                        color : ['#454951']
                    }
                },
                axisLabel:{
                    formatter:(value, index) => {
                        const prefix = value < 0 ? "-" : "";
                        const val = Math.abs(value);
                        if (val < 1000) {
                            if(val <= 0.1) {
                                return val.toFixed(2);
                            }
                            return val.toFixed(1);
                        }
                        const SUFFIXES  = ['', 'K', 'M', 'G', 'T', 'P', "E", "Z", "Y"];
                        const suffixNum = Math.floor( (""+val).length / 3 );
                        let shortValue  = parseFloat((suffixNum != 0 ? (value / Math.pow(1000,suffixNum)) : val).toPrecision(2));
                        if( shortValue <= 0.1) shortValue = shortValue.toFixed(2);
                        else if (shortValue % 1 != 0) shortValue = shortValue.toFixed(1);
                        return prefix + Math.abs(shortValue) + SUFFIXES[suffixNum];
                    }
                }
            },
            animationDuration: 200
        }
    }

    _getTooltipFormatter(params) {
            const div  = params.reduce((acc, cur, i) => {
            const date = params[0].axisValueLabel;

            if (cur.seriesType == 'candlestick') {
                const open = cur.data[1];
                const close = cur.data[2];
                const low = cur.data[3];
                const high = cur.data[4];
                return acc += `
                    <p class="time-wrap">${date}</p>
                    <div class="gradient-line" style="margin-bottom:10px;"></div>
                    <section class="formatter-section">
                        <div class="formatter-wrapper">
                            <p>Open  : ${open}</p>
                            <p>Close : ${close}</p>
                            <p>Low   : ${low}</p>
                            <p>High  : ${high}</p>
                        </div>
                    </section>
                `;
            }


            if (cur.seriesType == 'line') {
                if (cur.seriesName == "Negative" || cur.seriesName == "Positive") {
                    return '';
                }

                if (cur.seriesName === "cue_signal") {
                    if (cur.data) {
                        const buySell = cur.data.signal == 'L' ? 'Buy' : 'Sell';
                        return acc += `
                            <div class="gradient-line" style="margin-bottom:10px; margin-top:10px;"></div>
                            <section class="formatter-section">
                                <div class="formatter-wrapper">
                                    <p class="buyType ${buySell}">Recommended ${buySell}</p>
                                    <p> ${cur.data.recom_price} </p>
                                </div>
                            </section>
                        `;

                    }
                }

                if (cur.seriesName === "risingSignal" && cur.data) {
                    const [entry_start, entry_end, take_start, take_end, stop] = cur.data.split(',')
                    return acc += `
                        <div class="gradient-line" style="margin-bottom:10px; margin-top:10px;"></div>
                        <section class="formatter-section">
                            <div class="formatter-wrapper">
                                <p>Entry : <span class="meta-entry">${entry_start} ~ ${entry_end}<span></p>
                                <p class="meta-take">Take  : ${take_start} ~ ${take_end}</p>
                                <p class="meta-stop">Stop  : ${stop} </p>
                            </div>
                        </section>
                    `;
                }

                if (cur.seriesName === "AO") {
                    if (!cur.data.buyType) return ``;
                    const typeClass = cur.data.buyType === "BUY" ? "long" : "short";
                    return acc += `
                        <section class="formatter-section">
                            <div class="formatter-wrapper">
                                <p class="buyType ${typeClass}">Recomended ${cur.data.buyType}</p>
                                <p >from to </p>
                            </div>
                        </section>
                    `;
                } else {
                    const line = cur.data;
                    const name = cur.seriesName;
                    const isKibotLine = name == 'Kibot Line';
                    let text = '';
                    if(isKibotLine) {
                        text = `<p class="${isKibotLine ? 'kibot-line' : ''}">${name} : ${line}</p>`
                    }
                    return acc += `
                        <section class="formatter-section">
                            <div class="formatter-wrapper">
                                ${text}
                            </div>
                        </section>
                    `;
                }

            }

        }, `<div class='tooltip-wrap'>`) + "</div>";
        return div;
    }
    /**
     *
     * @param {Object} xAxis {type : time, typeFormat : {HH:MM}}
     * typeFormat {MM}-{dd}, {HH}:{mm} ....
     * @returns
     */
    getxAxis(xAxis) {
        return {
            type      : xAxis.type || 'time',
            axisLabel : { formatter: xAxis.typeFormat || `{HH}:{mm}` },
            axisTick  : { show:true },
        }
    }

}